import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import { COLOR_BLACK } from '../../lib/colors'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

function UITitle({ label, dynamicStyle }) {
  return <h1 className={css(styles.default, dynamicStyle)}>{label}</h1>
}

const styles = StyleSheet.create({
  default: {
    fontSize: 30,
    fontWeight: 700,
    color: COLOR_BLACK,
    [MEDIA_MIN_SM]: {
      fontSize: 48,
    },
  },
})

UITitle.propTypes = {
  label: PropTypes.string.isRequired,
  dynamicStyle: PropTypes.node,
}

export default UITitle
